import { object, string } from 'yup';

export const recalculateSchema = () => {
    return object().shape({        
        assignmentDate: string().typeError('Data da cessão: precisa ser preenchido').required('Data da cessão: precisa ser preenchido')
    });
};